import type { HasSeenItKey, HasSeenPrefixedKey } from './types.tsx';

export const createHasSeenPrefixedKey = (key: HasSeenItKey): HasSeenPrefixedKey => {
	return `hasSeen-${key}`;
};
